import { useCallback, useContext, useEffect, useState } from "react";
import { useLocation, useNavigate } from "react-router-dom";
import { Dropdown, Avatar } from "flowbite-react";
import { GiFullMotorcycleHelmet, GiTeacher } from "react-icons/gi";
import {
  FaMotorcycle,
  FaPeopleArrows,
  FaTrailer,
  FaBox,
  FaArrowRightArrowLeft,
  FaHandHoldingDollar,
  FaSackDollar,
} from "react-icons/fa6";
import {
  MdEngineering,
  MdOutlineAttachMoney,
  MdOutlineCreditScore,
  MdOutlineDragIndicator,
  MdOutlinePeople,
  MdOutlineSpaceDashboard,
  MdOutlineSupportAgent,
  MdWork,
} from "react-icons/md";
import {
  BsClipboardData,
  BsCollectionPlayFill,
  BsPersonFillExclamation,
  BsSignStopLightsFill,
  BsWrenchAdjustableCircle,
} from "react-icons/bs";
import { FiChevronDown } from "react-icons/fi";
import { GrHostMaintenance } from "react-icons/gr";
import Permission from "../../../auth/Permission";
import { AuthContext } from "../../../auth/authContext/AuthContext";
import "./ManuHamburguer.scss";
import {
  FaBoxes,
  FaBuilding,
  FaElementor,
  FaFileInvoice,
  FaFireExtinguisher,
  FaMoneyCheckAlt,
  FaSearch,
  FaTools,
  FaUserFriends,
} from "react-icons/fa";
import { BiSolidUserX } from "react-icons/bi";
import { RxDashboard } from "react-icons/rx";
import { PiMotorcycleFill, PiUserSwitchDuotone } from "react-icons/pi";
import { SiCashapp, SiGoogleadsense } from "react-icons/si";
import { RiNewspaperLine } from "react-icons/ri";
import { TbLockDollar, TbUserDollar } from "react-icons/tb";

export default function MenuHamburguer() {
  const navigate = useNavigate();
  const location = useLocation();
  const { auth } = useContext(AuthContext);

  /* ---------- helper ---------- */
  const isActive = useCallback(
    (thePath: string) => location.pathname.startsWith(thePath),
    [location.pathname],
  );

  /* ---------- estado ---------- */
  const [openGroups, setOpenGroups] = useState<Record<string, boolean>>(() => {
    const stored = localStorage.getItem("mhOpenGroups");
    return stored ? JSON.parse(stored) : {};
  });

  /* ---------- persist ---------- */
  useEffect(() => {
    localStorage.setItem("mhOpenGroups", JSON.stringify(openGroups));
  }, [openGroups]);

  /* ---------- toggle ---------- */
  const toggleGroup = (label: string) => {
    setOpenGroups((prev) => {
      const updated: Record<string, boolean> = {};
      Object.keys(prev).forEach((k) => {
        updated[k] = false;
      });
      updated[label] = !prev[label];
      return updated;
    });
  };

  /* ---------- structure ---------- */
  const menuStructure = [
    {
      label: "Dashboard",
      icon: RxDashboard,
      items: [
        {
          permission: "view:vehicles",
          path: "/dashboard/frota",
          label: "Frota",
          icon: PiMotorcycleFill,
        },

        {
          permission: "view:leads",
          path: "/dashboard/leads",
          label: "Comercial",
          icon: SiGoogleadsense,
        },
        {
          permission: "view:leads",
          path: "/dashboard/atendimento",
          label: "Atendimento",
          icon: MdOutlineSupportAgent,
        },
        {
          permission: "view:dashboard-maintenance",
          path: "/dashboard/manutencao",
          label: "Manutenção",
          icon: GrHostMaintenance,
        },
      ],
    },
    {
      label: "Cadastros",
      icon: FaUserFriends,
      items: [
        {
          permission: "view:renters",
          path: "/clientes",
          label: "Ativos",
          icon: GiFullMotorcycleHelmet,
        },
        {
          permission: "view:delinquency",
          label: "Recolhimento/Aguardando",
          path: "/aguardandoRecisao",
          icon: BsPersonFillExclamation,
        },
        {
          permission: "view:delinquency",
          label: "Finalizado/Rescisão",
          path: "/finalizados",
          icon: BiSolidUserX,
        },
        {
          permission: "view:leads",
          label: "Leads",
          path: "/leads",
          icon: () => (
            <img src="/lead-icon.svg" className="h-5 w-5" alt="Leads" />
          ),
        },
        {
          permission: "view:indicators",
          label: "Embaixadores",
          path: "/indicadores",
          icon: FaPeopleArrows,
        },
        {
          permission: "view:partners",
          label: "Parceiros",
          path: "/parceiros",
          icon: () => (
            <img src="/partnes-icon.svg" className="h-5 w-5" alt="Parceiros" />
          ),
        },
        {
          permission: "view:suppliers",
          label: "Fornecedores",
          path: "/fornecedores",
          icon: FaBuilding,
        },
        {
          permission: "view:companies",
          path: "/company-management",
          label: "Empresas",
          icon: MdWork,
        },
        {
          permission: "view:companies",
          path: "/locacoesB2B",
          label: "Locações B2B",
          icon: MdWork,
        },
      ],
    },
    {
      label: "Frota",
      icon: MdEngineering,
      items: [
        {
          permission: "view:vehicles",
          label: "Gestão Operacional",
          path: "/operational-management",
          icon: MdOutlineSpaceDashboard,
        },
        {
          permission: "view:vehicles",
          label: "Manutenções",
          path: "/maintenances",
          icon: GrHostMaintenance,
        },
        {
          permission: "view:vehicles",
          label: "Veículos",
          path: "/veiculos",
          icon: FaMotorcycle,
        },
        {
          permission: "view:inventories",
          label: "Inventário",
          path: "/inventario",
          icon: FaBoxes,
        },
        {
          permission: "view:maintenance-schedule",
          label: "Agend. Manutenções",
          path: "/maintenance-schedules",
          icon: BsWrenchAdjustableCircle,
        },
        {
          permission: "view:maintenance",
          label: "Manutenção",
          path: "/manutencao",
          icon: FaTools,
        },
        {
          permission: "menu:repossession",
          label: "Recolhimento",
          path: "/recolhimento",
          icon: FaTrailer,
        },
        {
          permission: "menu:repossession",
          label: "Eventos",
          path: "/event-claim",
          icon: FaFireExtinguisher,
        },
        {
          permission: "view:vehicles",
          label: "Transferências de Veículos",
          path: "/vehicle-transfer",
          icon: FaArrowRightArrowLeft,
        },
        {
          permission: "audits:vehicles",
          label: "Auditorias",
          path: "/audits",
          icon: FaSearch,
        },
      ],
    },
    {
      label: "Financeiro",
      icon: FaMoneyCheckAlt,
      permission: "role:financial",
      items: [
        {
          permission: "role:financial",
          label: "Gestão de Cobranças",
          path: "/financeiro/gestao-cobranca",
          icon: MdOutlineCreditScore,
        },
        {
          permission: "role:financial",
          label: "Cobranças Parceiros",
          path: "/financeiro/cobrancas-parceiros",
          icon: FaBuilding,
        },
        {
          permission: "role:financial",
          label: "Gestão de Faturas",
          path: "/financeiro/gestao-fatura",
          icon: FaHandHoldingDollar,
        },
        {
          permission: "role:financial",
          label: "Cobranças Negativadas",
          path: "/financeiro/negativados",
          icon: TbLockDollar,
        },
        {
          permission: "view:invoice-operation",
          label: "Gestão de Notas Fiscais",
          path: "/financeiro/gestao-fiscal",
          icon: FaFileInvoice,
        },
        {
          permission: "role:financial",
          label: "Boletos de Infrações",
          path: "/financeiro/infractionTickets",
          icon: RiNewspaperLine,
        },
        {
          permission: "role:financial",
          label: "Emprestimo",
          path: "/financeiro/emprestimo",
          icon: FaSackDollar,
        },
        {
          permission: "role:financial",
          label: "Devoluções de cauções",
          path: "/financeiro/caucao",
          icon: TbUserDollar,
        },
        {
          permission: "role:financial",
          label: "Renovações automaticas",
          path: "/financeiro/automaticRenewals",
          icon: PiUserSwitchDuotone,
        },
      ],
    },
    {
      label: "Estoque",
      icon: FaBox,
      items: [
        {
          permission: "view:stocks",
          label: "Estoque",
          path: "/estoque",
          icon: FaBox,
        },
        {
          permission: "view:purchase-order",
          label: "Compras",
          path: "/compras",
          icon: MdOutlineAttachMoney,
        },
      ],
    },
    {
      label: "Relatórios",
      icon: BsClipboardData,
      items: [
        {
          permission: "view:reports-maintenance",
          label: "Relatório de Manutenção",
          path: "/relatorios/manutencao",
          icon: GrHostMaintenance,
        },
        {
          permission: "view:reports-preparations",
          label: "Relatório de Preparações",
          path: "/relatorios/preparacoes",
          icon: FaMotorcycle,
        },
        {
          permission: "view:reports-trafficfines",
          label: "Relatório de Multas",
          path: "/relatorios/multas",
          icon: BsSignStopLightsFill,
        },
        {
          permission: "view:reports-repossession",
          label: "Relatório de Recolhimento",
          path: "/relatorios/recolhimento",
          icon: FaTrailer,
        },
        {
          permission: "view:reports-commissions",
          label: "Relatório de Bonificações",
          path: "/relatorios/comissoes",
          icon: SiCashapp,
        },
        {
          permission: "view:reports-commissions",
          label: "Relatório de Indicações",
          path: "/relatorios/RelatorioIndicacoes",
          icon: MdOutlineDragIndicator,
        },
        {
          permission: "view:reports-contests",
          label: "Contestações",
          path: "/relatorios/contestacoes",
          icon: FaElementor,
        },
      ],
    },
    {
      label: "Recursos Humanos",
      icon: MdOutlinePeople,
      items: [
        {
          permission: "view:employee",
          label: "Colaboradores",
          path: "/colaboradores",
          icon: FaPeopleArrows,
        },
      ],
    },
    {
      label: "Suporte",
      icon: BsCollectionPlayFill,
      items: [
        {
          permission: "view:tutorial",
          label: "Tutorial",
          path: "/tutoriais",
          icon: GiTeacher,
        },
      ],
    },
  ];

  /* ---------- ambassador rule ---------- */
  const isAmbassador =
    auth?.user?.roles?.length === 1 &&
    auth?.user?.roles?.includes("ambassador");
  const structureToRender = isAmbassador
    ? menuStructure.filter((g) => g.label === "Cadastros")
    : menuStructure;

  /* ---------- render ---------- */
  return isAmbassador ? (
    <Dropdown
      className="dropdown"
      label={
        <Avatar className="avatar" alt="Menu" img="/list-bold.svg" rounded />
      }
      arrowIcon={false}
      inline
    >
      {structureToRender[0]?.items?.map((item) => (
        <Permission key={item.path} permission={item.permission}>
          <Dropdown.Item
            icon={item.icon}
            onClick={() => navigate(item.path)}
            className={`dropdown-item ${
              isActive(item.path) ? "dropdown-item-active" : ""
            }`}
          >
            {item.label}
          </Dropdown.Item>
        </Permission>
      ))}
    </Dropdown>
  ) : (
    <Dropdown
      className="dropdown"
      label={
        <Avatar className="avatar" alt="Menu" img="/list-bold.svg" rounded />
      }
      arrowIcon={false}
      inline
    >
      {structureToRender.map((group) => {
        // itens realmente permitidos
        const groupItems = group.items?.filter((item) =>
          auth?.user?.permissions?.includes(item.permission),
        );

        if (!groupItems.length) return null; // nenhum item → não mostra o grupo

        const isGroupActive = groupItems.some((item) => isActive(item.path));

        return (
          <div key={group.label} className="dropdown-group select-none">
            {/* ── cabeçalho do grupo ── */}
            <div
              role="button"
              onClick={(e) => {
                e.stopPropagation();
                toggleGroup(group.label);
              }}
              className={
                `dropdown-top flex items-center gap-2 py-2 px-4 cursor-pointer rounded hover:bg-gray-100 ` +
                `dark:hover:bg-gray-600 ${
                  isGroupActive ? "dropdown-item-active" : ""
                }`
              }
            >
              <group.icon className="h-5 w-5" />
              <span className="grow text-sm">{group.label}</span>
              <FiChevronDown
                className={`transition-transform ${
                  openGroups[group.label] ? "rotate-180" : ""
                }`}
              />
            </div>

            {/* ── sub-menus ── */}
            {openGroups[group.label] &&
              groupItems.map((item) => (
                <Permission key={item.path} permission={item.permission}>
                  <Dropdown.Item
                    icon={item.icon}
                    onClick={() => navigate(item.path)}
                    className={`dropdown-item pl-9 ${
                      isActive(item.path) ? "dropdown-item-active" : ""
                    }`}
                  >
                    {item.label}
                  </Dropdown.Item>
                </Permission>
              ))}
          </div>
        );
      })}
    </Dropdown>
  );
}
